import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { PaymentService } from './../../../../../rest/api/payment.service';
import { AuthService } from './../../../../../services/auth.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { HelperService } from './../../../../../services/helper.service';
import { ScrollHelper } from './../../../../../services/scroll-helper.service';

import * as _ from 'lodash';

@Component({
  selector: 'app-shop-camera',
  templateUrl: './shop-camera.component.html',
  styleUrls: ['./shop-camera.component.scss']
})
export class ShopCameraComponent implements OnInit {
  @Output() addCameraSubscriptionEmit = new EventEmitter();

  accessToken: any;
  cameraPlansData: any;
  cameraPlansLoader = true;
  taxPercentage = 0;

  // PAYMENT CARD INFO
  cardData: any;
  cardLoader = true;

  // Payment form
  createPaymentFormSubmitted = false;
  createPaymentForm: FormGroup;
  ccvCodeRegex = '^[0-9]{3,4}$';
  isSubmittingPaymentForm = false;
  isSubmittedPaymentForm = false;

  isSubmitting = false;
  isSubmitted = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public paymentService: PaymentService,
    public helperService: HelperService,
    public scrollHelper: ScrollHelper,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.createPaymentFormInit();
    this.getPlans();
    this.getPaymentCard();
  }

  getPlans() {
    this.paymentService.getPlans().subscribe((response: any) => {
      this.cameraPlansData  = response && response.plan ? _.find(response.plan, {plan_type: 'camera'}) : undefined;
      const subscriptionPlan  = response && response.plan ? _.find(response.plan, {plan_type: 'subscription'}) : false;
      if (subscriptionPlan && subscriptionPlan.tax) {
        this.taxPercentage = subscriptionPlan.tax;
      }
      this.cameraPlansLoader = false;
    }, err => {
      this.cameraPlansLoader = false;
    });
  }

  getPaymentCard() {
    this.memberService.getPaymentCard(this.accessToken).subscribe((response: any) => {
      const cardsList = response && response.data ? response.data : [];
      this.cardData = _.find(cardsList, {DefaultFlag: '1'});
      this.cardLoader = false;
    }, err => {
      this.cardLoader = false;
    });
  }

  seperateDateFormat(carddate) {
    const splitted = carddate.match(/(.{1,2})/g);
    return splitted[0] && splitted[1] ? splitted[1] + '/' + splitted[0] : '-';
  }

  // Payment form cvv
  createPaymentFormInit() {
    this.createPaymentForm = this.fb.group({
      // ccvCode: ['', [Validators.required, Validators.pattern(this.ccvCodeRegex)] ],
    });
  }

  submitPaymentForm(value) {
    if (!this.createPaymentForm.valid) {
      this.isSubmittingPaymentForm = true;
      // this.scrollHelper.scrollToFirst('has__error');
      return;
    }
    if (this.isSubmittedPaymentForm) {
      return;
    }
    this.isSubmittedPaymentForm = true;
    setTimeout(() => {
      this.createPaymentFormSubmitted = true;
      this.isSubmittingPaymentForm = false;
      this.isSubmittedPaymentForm = false;
    }, 1000);
  }

  backtoPaymentForm() {
    this.createPaymentFormSubmitted = false;
  }

  submitForm() {
    if (!this.createPaymentForm.valid) {
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    const data = {
      // cvv: this.createPaymentForm.value.ccvCode,
      amount: this.getTotalPrice()
    };
    this.createCameraSubscription(data);
    // const data = this.createSpaceForm.value;
    // if (this.publishedDate && this.publishedDate.nativeElement && this.publishedDate.nativeElement.value) {
    //   data.published_date = this.publishedDate.nativeElement.value;
    // }
    // data.cvv = this.createPaymentForm.value.ccvCode;
    // this.createSpace(data);
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  createCameraSubscription(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.addCameraSubscription({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'You have successfully subscribed camera features.';
      this.scrollHelper.scrollToFirst('alert-success');
      setTimeout(() => {
        this.resetErrorValues();
        document.getElementById('closeCameraSubscriptionModal').click();
        const responseData = response && response.data ? response.data : undefined;
        this.addCameraSubscriptionEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.createPaymentForm.reset();
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while creating space.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.scrollHelper.scrollToFirst('alert-danger');
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.errorMsg = undefined;
    this.successMsg = undefined;
    this.isSubmitting = false;
    this.isSubmitted = false;
    this.createPaymentFormSubmitted = false;
    this.createPaymentForm.reset();
  }

  getSubTotalPrice() {
    const subsriptionPrice = this.cameraPlansData && this.cameraPlansData.new_price ? this.cameraPlansData.new_price : 0;
    return subsriptionPrice;
  }

  getTaxAmount() {
    if (this.taxPercentage && this.taxPercentage > 0) {
      const subTotalPrice = this.getSubTotalPrice();
      const taxAmount = subTotalPrice * this.taxPercentage / 100;
      return Math.round(taxAmount);
    }
    return 0;
  }

  getTotalPrice() {
    return this.getSubTotalPrice() + this.getTaxAmount();
  }

}
